module.exports = __webpack_public_path__ + "img/block51.8c4942c4.svg";